import React, { Component } from 'react';


export default class EndOfSurvey extends Component {

    state={whoTapped:false, shareTapped:false, linkCopied:false}

	render() {
		const {style, title, description, aboutLinkTitle, aboutLink, shareLinkTitle, shareLink, hideKaymaLinks, hideShareLink, hideAboutLink} = this.props;
		const padding = 40;
		

        return <div style={style}>
            <div style={{
                 position: "absolute",
				 bottom: 0,
				 height: 300,
                 right: padding,
                 left: padding,
                 textAlign: "right",
            }}>
                <h1>{title}</h1>
                <div className="separation-bar"/>
                <div className= 'paragraph'>{description.split('\n').map( i=>{return <div key={i}>{i}</div>})}</div>
            </div>

            <div id="kayma_links" style={{
					position:"absolute",
					display: hideKaymaLinks ? "none" : "",
					bottom: 40,
					right: padding,
					left: padding,
					height: 100,
					// backgroundColor:"rgba(200,40,40,0.3)"
				}}>

                <span style={{
						position:"absolute",
						display: hideShareLink ? "none" : "",
						right: 0,
						bottom: 50,
						height:30,
						textAlign: "right",
						fontSize: 20,
						cursor: "pointer",
						color: this.state.shareTapped || this.state.linkCopied ? "black" : global.colorTheme.main,
						borderBottom: this.state.shareTapped ? "2px solid #000" : "",
						transition: "all 0.3s"
					} } onClick={() => {

						
						// if (navigator.share) {
						// 	navigator.share({
						// 		title: 'המעבדה של דן אריאלי',
						// 		text: 'הצטרפו למערך הניסויים שלנו',
						// 		url: shareLink,
						// 	})
						// 	.then(() => console.log('Successful share'))
						// 	.catch((error) => console.log('Error sharing', error));
						// } else {
						this.CopyToClipboard(shareLink);
						this.setState({linkCopied:true});
						// }
						}}
						onTouchStart={()=>{this.setState({shareTapped:true})}}
						onTouchEnd={()=>{this.setState({shareTapped:false})}}
                        onTouchCancel={()=>{this.setState({shareTapped:false})}}
                        
                        onMouseEnter={()=>{this.setState({shareTapped:true})}}
					    onMouseLeave={()=>{this.setState({shareTapped:false})}}
					> {this.state.linkCopied ? "הלינק הועתק	📋" : `${shareLinkTitle} ⇱`} </span>

                <span style={{
						position:"absolute",
						display: hideAboutLink ? "none" : "",
						right: 0,
						bottom: 0,
						height:30,
						textAlign: "right",
						fontSize: 20,
						cursor: "pointer",
						color: this.state.whoTapped ? "black" : global.colorTheme.main,
						borderBottom: this.state.whoTapped ? "2px solid #000" : "",
						transition: "all 0.3s"
					}}
						onClick={() => {window.open(aboutLink, "_blank")}}
						onTouchStart={()=>{this.setState({whoTapped:true})}}
						onTouchEnd={()=>{this.setState({whoTapped:false})}}
                        onTouchCancel={()=>{this.setState({whoTapped:false})}}
                        
                        onMouseEnter={()=>{this.setState({whoTapped:true})}}
					    onMouseLeave={()=>{this.setState({whoTapped:false})}}
					> {aboutLinkTitle} </span>
            </div>
	  	</div>
    }
    
    CopyToClipboard(str) {
		const el = document.createElement('textarea');
		el.value = str;
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	};
}



// WEBPACK FOOTER //
// ./src/Comp/EndOfSurvey.js